import { render, staticRenderFns } from "./AppVersionManager.vue?vue&type=template&id=1098811b&scoped=true"
import script from "./AppVersionManager.vue?vue&type=script&lang=js"
export * from "./AppVersionManager.vue?vue&type=script&lang=js"
import style0 from "./AppVersionManager.vue?vue&type=style&index=0&id=1098811b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1098811b",
  null
  
)

export default component.exports